export default function B2Bsteps() {
  return (
    <>
      <style>{`
        .journey-bg-mobile {
          background-image: url('/b2b/b2bwhom.webp');
        }
        @media (min-width: 768px) {
          .journey-bg-mobile {
            background-image: url('/b2b/b2bwhod.webp');
          }
           }
            .journey-height {
            height: 600px !important;
          }
        }
        @media (min-width: 1450px) {
          .journey-height {
            height: 650px !important;
          }
        }
         @media (min-width: 1550px) {
          .journey-height {
            height: 790px !important;
          }
        }
      `}</style>
      <div
        className="w-full bg-[#08090A] text-white font-fira-sans"
        style={{
    
          borderBottom: "1px solid rgba(255,255,255,0.2)",
        }}
      >
        {/* Framed container */}
        <div
          className="w-[90%] md:w-auto mx-auto md:mx-[153px] journey-bg-mobile"
          style={{
            borderLeft: "1px solid rgba(255,255,255,0.2)",
            borderRight: "1px solid rgba(255,255,255,0.2)",
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          {/* Background image lives INSIDE frame */}
          <div
            className="relative py-12 md:py-28 h-[610px] journey-height"
            style={{}}
          >
            {/* Content */}
            <div className="relative md:pl-[60px] md:pr-[60px] px-4">
              {/* Heading */}
              <p className="text-[16px] tracking-[1.75px] leading-[160%] font-normal uppercase text-white/60 mb-2">
                AI for all stages
              </p>

              <h2 className="text-[30px] md:text-[38px] leading-[120%] font-medium text-white mb-24">
                Who is Outskill for?
              </h2>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
